import api from '../../../App/socket';

export const editGroupModulePermissions = (group, url, permissions) => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'SetGroupPermissions',
        options: { group, url, permissions },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/requests/edit_group_module_permissions_request.js